export const WEBSX = { sm: "none", xs: "none", md: "inherit" };
export const MOBILESX = { sm: "inherit", xs: "inherit", md: "none", lg: "none", xl: "none" };
export const TABLETSX = { sm: "inherit", xs: "inherit", md: "inherit", lg: "none", xl: "none" };
